module.exports = __webpack_public_path__ + "static/media/ми.d43167e5.mp3";